'use client';

import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { BlocksButton } from '@blocks-web-components/components/button/button';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';

interface DrawerBackHeaderProps {
  className?: string;
  handleClose: () => void;
  isActive?: boolean;
}

export const DrawerBackHeader: FC<PropsWithChildren<DrawerBackHeaderProps>> = ({
  children,
  className,
  handleClose,
  isActive = false
}) => {
  const buttonRef = useRef<BlocksButton>(null);

  //setTimeout because we need to wait for the drawer/modal to open to apply the focus
  useEffect(() => {
    if (isActive && buttonRef) {
      setTimeout(() => {
        buttonRef.current?.focus();
      }, 250);
    }
  }, [isActive, buttonRef]);

  return (
    <div
      slot="header"
      className={`${className} cat-u-display-flex`}
      style={{ gap: '8px' }}
    >
      <CatButton
        variant="ghost"
        hideText={true}
        onClick={handleClose}
        ref={buttonRef}
      >
        <CatIconArrowBack slot="before" />
      </CatButton>
      {children}
    </div>
  );
};
